export default "__VITE_ASSET__DMI4m5lo__"